module.exports = __webpack_public_path__ + "static/img/lab-3.412333fe.jpg";